var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65947 10.1654C4.65947 6.76888 7.41292 4.01543 10.8095 4.01543C14.206 4.01543 16.9595 6.76888 16.9595 10.1654C16.9595 13.562 14.206 16.3154 10.8095 16.3154C7.41292 16.3154 4.65947 13.562 4.65947 10.1654ZM10.8095 2.31543C6.47404 2.31543 2.95947 5.82999 2.95947 10.1654C2.95947 14.5009 6.47404 18.0154 10.8095 18.0154C12.671 18.0154 14.3812 17.3675 15.7268 16.2848L21.2084 21.7665C21.5404 22.0984 22.0786 22.0984 22.4105 21.7665C22.7425 21.4345 22.7425 20.8963 22.4105 20.5644L16.9289 15.0827C18.0115 13.7371 18.6595 12.0269 18.6595 10.1654C18.6595 5.82999 15.1449 2.31543 10.8095 2.31543Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c32e9b7a.svg";
export { ForwardRef as ReactComponent };